<div *ngIf="!isWizard">
  <div class="sub-header">{{'onboarding.select_location' | translate}}</div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_location' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="locations" [(ngModel)]="config.Location" (onChange)="updateConfig()"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>


  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Sales Rep:
      <span class="help fa hubtiger-tooltip" pTooltip="Select Sales Rep"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="users" [(ngModel)]="config.SalesRep" (onChange)="updateConfig()"
                    placeholder="Select the default sales rep">
        </p-dropdown>
      </div>
    </div>
  </div>

  
</div>

<div *ngIf="isWizard">
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_location' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
  </div>

  <div class="row margin-top-32">
    <div class="col-md-12">
      <button type="submit" class="iso-round-button secondary" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.LocationID">
        {{ busy ? ('onboarding.button.please_wait' | translate) : (config.LocationID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}
      </button>
    </div>
  </div>
</div>


<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
